module.exports = __webpack_public_path__ + "media/categories/7099-ad3cee00.svg";